import { Component, OnInit } from '@angular/core';
import { LatestArticleService } from './latest-articles.service';
@Component({
  selector: 'app-latest-articles',
  templateUrl: './latest-articles.component.html',
  styleUrls: ['./latest-articles.component.scss']
})

export class LatestArticlesComponent implements OnInit {
  hebdo: any;
  data: any;
  echo: any;

  constructor(private latestArticleService: LatestArticleService) {

    this.getLatestDataArticle();
    this.getLatestEchoArticle();
    this.getLatestHebdoArticle();
  }

  getLatestEchoArticle() {
    this.latestArticleService.getLatestArticle("Echo").subscribe((response: any) => {
      this.echo = response.data.length > 0 ? response.data[0] : null;
    });
  }
  
  getLatestDataArticle() {
    this.latestArticleService.getLatestArticle("Data").subscribe((response: any) => {
      this.data = response.data.length > 0 ? response.data[0] : null;
    });
  }
  
  getLatestHebdoArticle() {
    this.latestArticleService.getLatestArticle("Hebdo").subscribe((response: any) => {
      this.hebdo = response.data.length > 0 ? response.data[0] : null;
    });
  }  

  ngOnInit(): void {

  }

  getImage(article: any) {

    // if(article?.category?.data.attributes.name == "Echo") 
    //   return article.image.data.attributes.url; //'assets/images/afrotech-echo.png'; 
    // else if(article?.category?.data.attributes.name == "Data")
    //   return 'assets/images/afrotech-data.png';
    // else if(article?.category?.data.attributes.name == "Hebdo")
    //   return 'assets/images/afrotech-hebdo-v2.png';
    
    return article?.image?.data.attributes.url || '';
  }
}
